import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class CrowdsaleHelperService {
    public savedCrowdsales$ = new BehaviorSubject<any>(null);
    public crowdsaleData$ = new BehaviorSubject<any>(null);
    public isWalletWhitelisted$ = new BehaviorSubject<boolean>(null);
    constructor() {}
}
